import React from "react";
import Link from "next/link";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "dark" | "light";
}

const Logo: React.FC<LogoProps> = ({
  className = "",
  size = "md",
  variant = "dark",
}) => {
  const sizeClasses = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl md:text-3xl",
  };

  const colorClasses = {
    dark: "text-hawkeye-700",
    light: "text-white",
  };

  return (
    <Link
      href="/"
      className={`font-heading font-bold ${sizeClasses[size]} ${colorClasses[variant]} flex items-center transition-all duration-300 hover:opacity-90 ${className}`}
    >
      <span className="mr-0">hawkeye</span>
      <span
        className={variant === "dark" ? "text-gray-500" : "text-hawkeye-300"}
      >
        .legal
      </span>
    </Link>
  );
};

export default Logo;
